import { JtagService } from "@services/jtag-service";

export default class AFSClickTracker {
  private static isOverIFrame: boolean = false;
  private static isFocusAcquired: boolean = false;
  private static jrConfigGlobal: JrConfigGlobal = window.jrConfigGlobal;

  private static handleFocus = (): void => {
    if (!AFSClickTracker.isFocusAcquired) {
      (<HTMLElement>document.activeElement).blur();
      window.focus();
      AFSClickTracker.isFocusAcquired = true;
    }
  }

  private static onMouseOut = (): void => {
    AFSClickTracker.handleFocus();
    AFSClickTracker.isOverIFrame = false;
  }

  private static onMouseOver = (): void => {
    AFSClickTracker.isOverIFrame = true;
  }

  private static onIFrameClick = (): void => {
    if (AFSClickTracker.isOverIFrame) {
      setTimeout(() => {
        AFSClickTracker.onClick();
      });
    }
  }

  private static onAFSClick = (type: string): void => {
    JtagService.trackCustomEvent('afs_clicks', {
      event_label: type,
      gclid: AFSClickTracker.jrConfigGlobal.user.gclid,
      country: AFSClickTracker.jrConfigGlobal.localeCountry
    });
    AFSClickTracker.handleFocus();
  }

  private static onClick = (): void => {
    const parentElement = document.activeElement?.parentElement;
    const parentElementId = parentElement?.id;
    const isMobileSerpAdsense = parentElement?.className.includes('adsense-serp-item');

    switch (parentElementId) {
      case 'atf-iframe-container':
        AFSClickTracker.onAFSClick('atf');
        break;

      case 'btf-iframe-container':
        AFSClickTracker.onAFSClick('btf');
        break;

      case 'jpp-iframe-container':
        AFSClickTracker.onAFSClick('jpp');
        break;

      default:
        AFSClickTracker.handleFocus();
        break;
    }

    if (isMobileSerpAdsense) {
      AFSClickTracker.onAFSClick('mobile_serp');
    }
  }

  private static doTrack = (): void => {
    window.addEventListener('blur', () => {
      setTimeout(() => {
        if (document.activeElement instanceof HTMLIFrameElement) {
          document.activeElement.onmouseover = AFSClickTracker.onMouseOver;
          document.activeElement.onmouseout = AFSClickTracker.onMouseOut;
          AFSClickTracker.onMouseOver();
          AFSClickTracker.onIFrameClick();
        }
      });
      AFSClickTracker.isFocusAcquired = false;
    }, false);
  }

  public static Track = (): void => {
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('DOMContentLoaded', AFSClickTracker.doTrack, false);
    }
  }
}